import React from 'react'
import './faq.css'  
import data from '../FaQ/faqdata'

function Faq() {
  return (
    <div>
      <div className="ra-home-main-accodiam">
              <div className="container">
                <h2>Why Choose Us? </h2>
                <div className="ra-home-accodiam">
                  <div className="container">
                    <div className="ra-home-accordions">
                      {data.accordionItems.map((item) => (
                        <div className="ra-home-accordion" key={item.id}>
                          <input type="checkbox" id={item.id} />
                          <label
                            htmlFor={item.id}
                            className="ra-home-accordion__header"
                          >
                            {item.header}
                          </label>
                          <div className="ra-home-accordion__content">
                            <p>{item.content}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </div>
  )
}

export default Faq;
